import React from 'react';
import * as S from './styles';

type Props = {
  title: string;
  onClick?: () => void;
  children?: React.ReactNode;
  showBackArrow?: boolean;
};

const ListHeader = ({
  title,
  onClick,
  children,
  showBackArrow = true,
}: Props) => {
  return (
    <S.ListHeader>
      <S.MainArea onClick={onClick}>
        <S.LeftArrowArea visible={showBackArrow}>
          <S.LeftArrow />
        </S.LeftArrowArea>
        <S.HeaderTitle>{title}</S.HeaderTitle>
      </S.MainArea>
      <S.ExtraContentArea>{children}</S.ExtraContentArea>
    </S.ListHeader>
  );
};

export default ListHeader;
